"use strict";

export default {
  faq: [
    {
      id: "01",
      question: "O que é e como funciona o plano Controle da Vivo?",
      answer:
        "Nos <strong>planos Vivo Controle</strong>, você recebe uma fatura com valor fixo todo mês, para ter o controle total dos seus gastos. Os benefícios do plano são mensais, não cumulativos para o mês seguinte e renovados a cada ciclo. Alguns planos possuem permanência mínima de 12 meses. Caso você saia do plano antes desse período, promocionalmente a VIVO não cobrara multa relativa a quebra de contrato de planos anuais previstas em regulamento",
    },
    // {
    //   id: "02",
    //   question: "Como funciona o benefício do WhatsApp ilimitado?",
    //   answer:
    //     "Você pode usar os serviços do WhatsApp, Waze e Moovit sem descontar da sua franquia de internet. O WhatsApp pode ser usado para envio e recebimento de mensagens, áudios, fotos, vídeos e chamadas de voz. As chamadas de vídeo são descontadas da franquia do plano.",
    // },
    {
      id: "03",
      question: "Eu falo ilimitado com números da Vivo?",
      answer:
        "Sim! Em todos os planos Vivo Controle você pode falar ilimitado com qualquer celular e fixo da Vivo de todo o Brasil. Para aproveitar o benefício, você deve utilizar o código 15 ao fazer a ligação.",
    },
    {
      id: "04",
      question: "Como funciona o Dobro de Gigas para Redes Sociais e Vídeo?",
      answer:
        "O cliente Vivo Controle pode adquirir um adicional de franquia de internet igual à franquia do seu plano pelo valor de R$5,00/mês para utilizar exclusivamente no Facebook, Instagram, Tik Tok, X, Pinterest, Tinder, Messenger e Youtube. O valor será cobrado juntamente ao plano na sua fatura mensal. A franquia para estes apps de  redes sociais e vídeo corresponde ao dobro da franquia do seu plano, sem considerar qualquer bônus. Por exemplo, se o plano tem 5GB, então você tem mais 5GB para acessar os aplicativos exclusivos para redes sociais.",
    },
    {
      id: "05",
      question:
        "Qual franquia é consumida primeiro quando eu tenho o Dobro de Gigas para Redes Sociais e Vídeo contratado?",
      answer:
        "Nas redes sociais inclusas, a franquia descontada é a franquia referente ao Dobro de Gigas para Redes Sociais e Vídeo. Após exceder esta, a franquia do plano começa a ser descontada.",
    },
    {
      id: "06",
      question: "Posso ligar para outras operadoras?",
      answer:
        "Sim, com Vivo Controle voce tem ligações ilimitadas para celulares de outras operadoras para todo Brasil utilizando o código 15!",
    },
    {
      id: "07",
      question: "Posso ligar para telefone fixo?",
      answer:
        "Nos planos Vivo Controle você fala ilimitado com qualquer telefone fixo de qualquer operadora do Brasil, ou seja, não desconta da sua franquia de minutos. Para aproveitar o benefício, você deve utilizar o código 15 ao fazer a ligação.",
    },
    {
      id: "08",
      question: "Como consultar meu saldo de Recarga?",
      answer: "",
    },
    {
      id: "09",
      question: "O que preciso para ter acesso e navegar na rede 5G?",
      answer:
        "<p>Para ter acesso a rede 5G da Vivo, é necessário ter um celular compatível com a tecnologia, estar dentro da área de cobertura 5G e ter um chip compatível.</p><p>Clientes com chip 4G já tem acesso à ultravelocidade da rede 5G. Para ter acesso à tecnologia 5G SA é necessário realizar a troca para o chip 5G.</p><p>Para saber mais sobre a rede 5G, clique <a href='https://www.vivo.com.br/para-voce/por-que-vivo/qualidade/5g'>aqui</a></p>",
    },
    {
      id: "10",
      question: "Como faço para alterar meu plano Vivo Controle?",
      answer: "",
    },
    {
      id: "11",
      question:
        "Já sou cliente Vivo, preciso mudar meu número para ter um plano Vivo Controle?",
      answer:
        "Não! Sendo cliente Vivo você pode efetuar a mudança para o plano Vivo Controle na sua linha atual, mantendo seu número. Caso seja cliente de outra operadora, nós fazemos a portabilidade para você.",
    },
    {
      id: "12",
      question: "Sou cliente de outra operadora, posso solicitar o plano?",
      answer:
        "Sim! Se você ainda não é cliente Vivo pode solicitar a portabilidade do seu número atual agora mesmo. Nós fazemos todo o processo para você, não é necessário entrar em contato com sua operadora atual. Você pode ir até uma loja Vivo ou então podemos enviar um chip Vivo para seu endereço sem nenhum custo.<br/><br /><strong>Capitais:</strong> até 3 dias úteis;<br /><strong>Demais cidades (exceto AM):</strong> até 6 dias úteis;<br /><strong>Amazonas:</strong> até 10 dias úteis.<br><br>Para garantir que sua portabilidade seja concluída é necessário que o número informado esteja ativo e a solicitação deve ser feita pelo titular da linha.",
    },
    {
      id: "13",
      question: "O que fazer se minha franquia de internet acabar?",
      answer:
        "Caso a franquia de internet acabe antes da renovação dos seus benefícios, você pode contratar pacotes adicionais para continuar navegando, basta enviar um SMS com a palavra NAV para o número 1515. Fique tranquilo! O WhatsApp continuará funcionando para envio e recebimento de mensagens, fotos, vídeos e chamadas de voz.",
    },
    {
      id: "14",
      question: "O que são Serviços Digitais com conteúdos exclusivos?",
      answer:
        "São aplicativos que já fazem parte do seu plano. Você pode fazer o download e acessar o conteúdo sem ter que contratar o serviço. Para saber mais sobre quais apps fazem parte dos planos Vivo Controle, clique aqui.",
    },
    {
      id: "15",
      question: "Posso comprar um aparelho junto com o plano?",
      answer:
        "Sim! Quando você compra o aparelho com o plano Vivo Controle você ganha um desconto especial no preço do aparelho, além disso ganha 1 GB por mês durante 12 meses. Com a compra do aparelho, você ficará fidelizado no plano por 12 meses. Caso você queira sair antes desse período, haverá uma multa.",
    },
    {
      id: "16",
      question: "O que é Conta Digital?",
      answer:
        "É uma forma de receber a sua conta por e-mail em vez de papel. Ao escolher receber a Conta Digital do seu Vivo Móvel, você ganha 3GB de internet todo mês! Além disso, não corre o risco de receber a conta com atraso e contribui para um planeta sustentável, porque não tem emissão desnecessária de papel. Você escolhe receber a Conta Digital na hora da contratação ou quando quiser pelo App Vivo.",
    },
    {
      id: "17",
      question: "O que é o Skeelo?",
      answer:
        "<p>O <strong>Skeelo</strong> é um aplicativo para você ler os ebooks mais vendidos do Brasil em qualquer hora ou lugar. Todo mês você receberá um ebook da sua escolha. Se você for aquelas pessoas que amam receber recomendações, então deixa com a gente! Vamos fazer sugestões mensais incríveis para você.</p><p>Faça parte da nossa comunidade de <strong>Skeelovers</strong> e aproveite cada obra literária!</p>",
    },
    {
      id: "18",
      question: "Como posso acessar e começar a utilizar o Skeelo?",
      answer:
        '<p>  Para iniciar leitura dos ebooks best-sellers no Skeelo, você precisa criar o seu cadastro e escolher entre: acesso  através dos ebooks gratuitos, acesso premium com contratação mensal através do Google Play, App Store ou utilização  através dos nossos parceiros como um benefício <a href="https://skeelo.app/parceiros">https://skeelo.app/parceiros</a></p><p>  Confira melhores detalhes na pergunta “Como posso contratar o Skeelo?”.<br /><br />O Skeelo pode ser acessado por meio  do aplicativo, disponível no Android e iOS.</p><p>  <br />&#9679; Baixar o app: <a href="https://skeelo.app/loja">https://skeelo.app/loja</a><br />&#9679; Site:  <a href="https://www.skeeloebooks.com.br/">https://www.skeeloebooks.com.br</a></p>',
    },
    {
      id: "19",
      question: "Como posso contratar o Skeelo?",
      answer:
        "<p>A contratação do <strong>Skeelo</strong> pode ser feita de duas formas:</p><p>  <strong>Lojas de aplicativos: </strong>você pode realizar a contratação diretamente no aplicativo, disponibilizado na  Apple App Store e no Google Play. Para isso, basta seguir as instruções exibidas na tela de assinatura. O custo e a  periodicidade de cobrança são:</p><p>· <strong>Apple App Store: </strong>R$23,90/mês.</p><p>· <strong>Google Play: </strong>R$23,90/mês.</p><p><strong>Empresas Parceiras</strong></p><p>  · <strong>Incluído no plano</strong>: nesta modalidade, o acesso ao Skeelo já está incluído no valor do plano  contratado, não envolvendo assim nenhum custo extra de assinatura ou manutenção.<br /><br />  Para saber quais planos estão contemplados, acesse os Termos de Uso.</p><p>  · <strong>Contratação avulsa</strong>: usuários que não possuem o Skeelo contemplado em seus planos, mas que desejam  realizar a contratação e o pagamento por meio de suas linhas de celular, podem realizar a contratação avulsa da  plataforma - caso a sua operadora ofereça essa modalidade.<br /><br />Para isso, você deve enviar um SMS com o comando  de ativação SKEELO para o número 6080.</p>",
    },
    {
      id: "20",
      question:
        "Algumas operadoras possuem mais de um plano disponível. Qual a diferença entre eles?",
      answer:
        '<p>  O que difere os planos é a relação de livros que são disponibilizados em cada um deles. O Skeelo entrega ebooks com  valor do mercado editorial compatíveis com o valor do plano, por este motivo temos algumas variações. Mas, de qualquer  forma, o nosso time de curadoria está sempre atento e atualizando.</p><br/><br/><table border="1">  <tr>    <td>Nome em fatura</td>    <td>Valor assinatura avulsa</td>    <td>Valor dos livros no varejo</td>  </tr>  <tr>    <td>      <p>Skeelo Super Light</p>    </td>    <td>      <p>R$ 4,80/semana</p>    </td>    <td>      <p>R$ 4,90 a R$ 6,90</p>    </td>  </tr>  <tr>    <td>      <p>Skeelo Light</p>    </td>    <td>      <p>N/A</p>    </td>    <td>      <p>R$ 7,90 a R$ 9,90</p>    </td>  </tr>  <tr>    <td>      <p>Skeelo Intermediário</p>    </td>    <td>      <p>N/A</p>    </td>    <td>      <p>R$ 10,90 a R$ 13,90</p>    </td>  </tr>  <tr>    <td>      <p>Skeelo Avançado</p>    </td>    <td>      <p>R$ 14,20/mês</p>    </td>    <td>      <p>R$ 14,90 a R$ 19,90</p>    </td>  </tr>  <tr>    <td>      <p>Skeelo Top</p>    </td>    <td>      <p>N/A</p>    </td>    <td>      <p>R$ 20,90 a R$ 23,90</p>    </td>  </tr>  <tr>    <td>      <p>Skeelo Premium</p>    </td>    <td>      <p>R$ 29,00/mês</p>    </td>    <td>      <p>R$ 29,90 a R$ 39,90</p>    </td>  </tr></table><br/><br/><p>  Para ativar o Skeelo Super Light , você deve enviar um SMS com o comando de ativação SMS-SEM-SKSL para o número 6080.  Para ativar o Skeelo Avançado, você deve enviar um SMS com o comando de ativação SMS-MEN-SKA para o número 6080. Para  ativar o Skeelo Premium, você deve enviar um SMS com o comando de ativação SMS-MEN-SKLP para o número 6080.</p>',
    },
    {
      id: "21",
      question:
        "Quais são os requisitos mínimos do Android e iOS para acessar o Skeelo?",
      answer:
        "<p>Aplicativos:</p><br/><p>· Android: versão 5.0 (Lollipop) e superiores<br /><br />· iOS: versão 12.0 e superiores</p>",
    },
    {
      id: "22",
      question: "Por que eu preciso colocar o meu CPF e número de celular?",
      answer:
        '<p>O Skeelo pode ser utilizado como um benefício através dos nossos parceiros  <a href="https://skeelo.app/parceiros">https://skeelo.app/parceiros</a>. Você pode ter mais de 1 parceiro como  benefício e precisamos entregar os ebooks disponíveis em cada plano. Para validar e unificar essas informações entre  parceiros, precisamos do CPF e número de celular que são os únicos dados que recebemos em comum. Se estiver tudo ok,  você será direcionado para a conclusão do cadastro ou, caso já seja cadastrado, para a tela de login.</p><p>  Se o seu CPF ou número não for localizado com um de nossos parceiros, você poderá acessar os nossos ebooks gratuitos,  contratar o <strong>Skeelo</strong> pelo próprio aplicativo ou de forma avulsa, caso a sua operadora ofereça essa  possibilidade.</p>',
    },
    {
      id: "23",
      question:
        "O meu número ou CPF não foi identificado como benefício. O que posso fazer?",
      answer:
        "<p>  Estamos trabalhando incansavelmente para que um maior número de planos das operadoras e outros parceiros contemple o  uso sem custo adicional do aplicativo, ampliando o acesso dos usuários à cultura com grandes ebooks best-sellers.<br /><br />Se  o seu caso for que o Skeelo está incluso no seu plano e mesmo assim você ainda não consegue concluir o cadastro, sem  custo adicional, envie um e-mail para contato@skeelo.app que o nosso time de Relacionamento ao Cliente prestará todo o  suporte necessário.</p><br/><p>  Enquanto o <strong>Skeelo</strong> estiver indisponível com um de nossos parceiros, você poderá  acessar os nossos ebooks gratuitos ou realizar a contratação por meio das lojas de aplicativo Google Play e App  Store.<br /><br />Acompanhe nossas redes sociais e fique por dentro das novidades em primeira mão!</p>",
    },
    {
      id: "24",
      question: "Quais as funcionalidades do leitor?",
      answer:
        "<p>Queremos oferecer a melhor experiência de leitura para vocês. Confira a seguir as principais funcionalidades:</p><br/><ul>  <li>Dicionário de palavras</li>  <li>Destaque de trechos</li>  <li>Controle do brilho da tela</li>  <li>Possibilidade de ativar o modo noturno</li>  <li>Aumentar ou diminuir a fonte</li>  <li>Trocar o tipo da fonte</li>  <li>Marcar e favoritar página</li>  <li>Leitura do ebook no formato horizontal e vertical</li>  <li>Voltar a leitura do ebook de onde parou na última vez</li>  <li>Escolher o capítulo de forma prática para iniciar a leitura</li></ul>",
    },
    {
      id: "25",
      question: "O Skeelo possui audiolivros?",
      answer:
        "<p>  O Skeelo é dedicado 100% aos ebooks. Mas, você pode ter a experiência completa de ouvir audiobooks no nosso outro  aplicativo da casa, chamado Skeelo Audiobooks. Ele funciona do mesmo jeito do Skeelo e você pode conferir todos os  detalhes em https://skeeloaudiobooks.com.br</p>",
    },
    {
      id: "26",
      question:
        "Como funciona para escolher ou trocar o ebook que irei receber?",
      answer:
        "<p>  Pensando nos usuários que amam receber recomendações de leituras, o time de curadoria do Skeelo sugere, de acordo com  a recorrência do plano (semanal, quinzenal ou mensal) 1 ebook específico, entretanto, dentro do prazo de troca entre  uma entrega e outra, você sempre poderá escolher a sua leitura em nosso acervo de trocas, clicando em &quot;trocar  livro&quot;, quantas vezes quiser. Você só não consegue efetuar a troca dos ebooks efetivamente entregues, após o  prazo de troca expirar.</p>",
    },
    {
      id: "27",
      question: "Depois de receber um ebook, eu posso trocá-lo?",
      answer:
        "<p>  Após o ebook ser efetivamente entregue, ele é seu de forma definitiva e não poderá ser substituído por outro.  Lembrando que você sempre poderá acessar a sua estante com o seu login e senha, independente do status da sua  assinatura no Skeelo.</p>",
    },
    {
      id: "28",
      question: "Os ebooks recebidos são meus de forma definitiva?",
      answer:
        "<p>  Sim, uma vez que o ebook é entregue, ele se torna seu de forma definitiva e estará disponível na sua estante para você  acessá-lo quando e onde quiser, através do seu login e senha.</p>",
    },
    {
      id: "29",
      question: "Posso fazer a leitura do ebook offline?",
      answer:
        "<p>  Ao acessar e concluir o download do ebook pela primeira vez conectado na internet – após isso, você poderá continuar a  leitura no modo offline, sem consumir sua internet.</p>",
    },
    {
      id: "30",
      question:
        "Posso baixar os livros ou compartilhar para colocar em outros players, como o Kindle, Lev e Kobo?",
      answer:
        "<p>  Não. Devido aos nossos contratos com os nossos parceiros a leitura só é permitida no aplicativo Skeelo. Não sendo  possível enviar ou compartilhar os arquivos para outros dispositivos. Tudo bem?</p>",
    },
    {
      id: "31",
      question: "Esqueci a minha senha. O que posso fazer?",
      answer:
        "<p>  É bem simples! Para recuperar a sua senha, basta clicar no botão “Esqueci a minha senha” que, na sequência, enviaremos  um link de recuperação para o e-mail informado no seu cadastro. Caso tenha qualquer dúvida, fique à vontade para  entrar em contato através do e-mail contato@skeelo.app.</p>",
    },
    {
      id: "32",
      question:
        "Como faço para cancelar a minha assinatura ou desativar a minha conta?",
      answer:
        "<p>O processo de cancelamento varia de acordo com o canal em que você realizou a assinatura. São eles:</p><br/><p>  <b><u>Lojas de aplicativos</u></b></p><br/><p>  · <b>Apple App Store: </b>acesse “Ajustes” &gt; [seu nome] &gt; iTunes e App Store &gt; ID Apple &gt; Ver o ID Apple  &gt; Assinaturas. Depois, basta selecionar a assinatura que deseja gerenciar e, por fim, confirmar o cancelamento por  meio do botão “<b>Cancelar assinatura</b>”.</p><br/><p>  · <b>Google Play: </b>acesse Google Play Store &gt; Assinaturas. Depois, basta selecionar a assinatura que deseja  gerenciar e, por fim, confirmar o cancelamento por meio do botão “<b>Cancelar assinatura</b>”.</p><p>  <b><u>Operadoras de telefonia celular e outros parceiros</u></b></p><p>  · <b>Incluído no plano</b>: para esta modalidade, você deverá entrar em contato com a operadora e solicitar o  cancelamento do serviço. Neste caso, o valor final do seu plano não sofre alteração com a retirada dos benefícios.<br /><br />  Você ainda pode optar por <b>desativar a sua conta</b> diretamente no app. Neste caso você continuará recebendo um  ebook por mês e poderá retornar quando você quiser.</p><p>  · <b>Contratação avulsa</b>: você deve enviar o comando <b>SAIR </b>para o mesmo número que utilizou para contratar o  serviço.</p>",
    },
    {
      id: "33",
      question: "Fiz portabilidade. E agora?",
      answer:
        "<p>  Calma! Os ebooks já entregues são seus e poderão ser acessados, através do aplicativo, onde e quando você quiser  através do seu login e senha. Para completar, caso o Skeelo também faça parte dos seus novos benefícios, você passará  a receber os ebooks no mesmo cadastro. Se ficar alguma dúvida, envie um e-mail para contato@skeelo.app que o nosso  time de Relacionamento ao Cliente prestará todo o suporte necessário.</p>",
    },

    {
      id: "34",
      question: "O que é o Super Comics - Clube de Quadrinhos?",
      answer:
        "<p>  O SuperComics – Clube de Quadrinhos é um serviço de conteúdo de entretenimento com histórias em quadrinhos. Os usuários podem acessar o conteúdo através de um app, que está disponível para smartphones e tablets Android e iOS.</p>",
    },
    {
      id: "35",
      question: "Como faço para assinar o Super Comics?",
      answer:
        "<p>  Você pode assinar diretamente no app, na opção MINHA CONTA dentro do seu perfil (botão no topo à direta). Clientes da operadora ViVO podem assinar o serviço enviando a palavra “HQ” para o número 77125. Depois, basta seguir com o fluxo de contratação.</p>",
    },
    {
      id: "36",
      question: "Quem pode assinar o Super Comics?",
      answer:
        "<p>  A assinatura do Super Comics pode ser feita por todos que tiverem interesse, seguindo as instruções acima.</p>",
    },
    {
      id: "37",
      question: "Quanto custa a assinatura do Super Comics?",
      answer:
        "<p>  Consulte as opções de planos de assinatura no menu MINHA CONTA do seu perfil dentro do app (botão no topo à direita). Clientes da operadora VIVO pagam R$ 3,99 pela assinatura semanal e R$ 11,99pela assinatura mensal. Os valores são descontados dos créditos, nos casos de clientes Pré-pago e Controle, ou direto na fatura, caso o cliente seja Pós-pago. Caso o cliente queira cancelar o serviço, basta enviar a palavra “SAIR” para o 77125.</p>",
    },
    {
      id: "38",
      question: "Quantas revistas em quadrinhos eu posso ler?",
      answer:
        "<p>  Você pode baixar e ler quantas revistas quiser! Mas lembre-se de que você precisa estar assinado no serviço e com status ativo. Sua assinatura é renovada automaticamente, de acordo com a periodicidade escolhida</p>",
    },
    {
      id: "39",
      question: "Com quais dispositivos o app do Super Comics é compatível?",
      answer:
        "<p>  O app do SuperComics é compatível com smartphones e tablets com sistemas operacionais Android® 6.0 (ou superior) ou iOS® 10.0 (ou superior).</p>",
    },
    {
      id: "40",
      question: "Como faço para cancelar minha assinatura?",
      answer:
        "<p>  Para assinaturas feitas via Apple iTunes (dispositivos iOS) ou Google Play Store(dispositivos Android), acesse o seu perfil no app para mais informações. Clientes da Operadora VIVO devem enviar a palavra “SAIR” para o número 77125.</p>",
    },
    {
      id: "41",
      question: "Como faço para obter mais informações?",
      answer:
        "<p>  Para obter mais informações, acesse a opção 'Fale com o Super Comics' dentro do seu perfil no app ou envie um e-mail para contato@supercomics.com.br.</p>",
    },
    {
      id: "42",
      question: "Como faço para baixar o app no meu celular ou tablet?",
      answer:
        "<p>  Para baixar o app, basta usar o link específico para o seu sistema operacional: <a href='https://play.google.com/store/apps/details?id=com.zedlatam.supercomics' target='_blank'>Baixar app para smartphone/tablet Android</a>; <a href='https://apps.apple.com/br/app/super-comics/id1327984849?l=en' target='_blank'>Baixar app para iPhone/iPad</a></p>",
    },
    {
      id: "43",
      question:
        "Caso eu não queira continuar no serviço após o período de gratuidade de 1 semana, devo solicitar o cancelamento do mesmo?",
      answer:
        "<p>  Sim. Após o período de gratuidade, a renovação do serviço é automática. Caso você não queira permanecer inscrito, é necessário enviar um SMS com a palavra SAIR para o número 77125</p>",
    },

    {
      id: "44",
      question: "Como adquirir o serviço?",
      answer:
        "<p>  Para Clientes VIVO elegíveis ao serviço em decorrência do plano de telefonia móvel contratado, basta fazer o cadastrono aplicativo.Para Clientes VIVO não elegíveis em decorrência do plano de telefonia móvel contratado, basta enviar de um telefoneVIVOum SMS com a palavra JORNAIS para o número 70071.</p>",
    },
    {
      id: "45",
      question: "Como faço para cancelar o serviço?",
      answer:
        "<p>  Basta enviar, do número VIVO assinado no serviço, um SMS com a palavra SAIR para 70071</p>",
    },
    {
      id: "46",
      question: "Como faço para acessar o conteúdo do serviço “hube Jornais”?",
      answer:
        "<p>  Somente clientes que possuem assinatura do “hube Jornais”, ou que sejam clientes VIVO elegíveis, podem acessar o conteúdo do serviço, utilizando o aplicativo compatível com smartphonese tablets Android e iOS</p>",
    },
    {
      id: "47",
      question:
        "Posso acessar o sistema “hube Jornais” enquanto estiver offline?",
      answer:
        "<p>  Ao acessar o conteúdo do“hubeJornais”pelos aplicativos para smartphonese tabletsAndroid e iOSvocê poderá ler as revistastanto online quantooffline. Você deve acessar,inicialmente,a banca virtual enquanto estiver online e baixar (fazer download) das revistas que deseja ler. Depois de baixadas, as revistas ficam disponíveis para leitura offline. Para liberar a memória do seu smartphone ou tablet, sugerimos queelimineas revistas baixadas para o modo offline após a leitura. Basta clicar no ícone da Lixeira na imagem de capa da revista.</p>",
    },
    {
      id: "48",
      question:
        "Meu celular é pré-pago. O que acontece se eu ficar sem crédito?",
      answer:
        "<p>  Caso você já tenha assinado o serviço e,durante o período,fique sem crédito, você poderá continuar acessando o conteúdo até a renovação da sua assinatura. Se,no momento de renovação da assinatura,você estiver sem crédito, a assinatura não será renovada. Ao colocar crédito e renovar a assinatura, você terá acesso novamente ao conteúdodo “hube Jornais”. Após 60 dias sem créditos, você é desligado(a) automaticamente do serviço.</p>",
    },
    {
      id: "49",
      question:
        "Se eu cancelar minha assinatura, ainda poderei acessar os conteúdos do “hubeJornais”?",
      answer:
        "<p>  Ao cancelar sua assinatura, seu número é desabilitado e você perde o acesso aos conteúdos do “hube Jornais”. Você pode assinar o serviço novamente, quando desejar.</p>",
    },
    {
      id: "50",
      question: "Cancelei a assinatura e me arrependi. O que faço?",
      answer:
        "<p>  Você pode assinar o serviço novamente, quando desejar. Sua assinatura será reativada e você poderá acessar todo o conteúdo do aplicativo .Basta enviar um SMS com a palavra JORNAIS ao número 70071 do seuVIVO.</p>",
    },
    {
      id: "51",
      question: "Posso compartilhar os arquivos com outras pessoas?",
      answer:
        "<p>  A assinatura é exclusiva, vinculada ao número do seu celular. Por isso, o serviço não permite compartilhamento de arquivos. Você poderá sim compartilhar o serviço “hube Jornais” via redes sociais, porém, somente clientes assinantes do serviço poderão acessar o conteúdo</p>",
    },
  ],
};
